import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TextToSpeechService {
  translateService = inject(TranslateService);

  constructor() {}

  speech({
    message,
    translatedMessageKey,
    lang = 'it-IT',
    rate = 0.9,
    pitch = 1.2,
    volume = 1,
  }: {
    message?: string;
    translatedMessageKey?: string;
    lang?: string;
    rate?: number;
    pitch?: number;
    volume?: number;
  }) {
    const messageToSpeech = message || this.translateService.instant(translatedMessageKey);
    const utterance = new SpeechSynthesisUtterance(messageToSpeech);
    utterance.lang = lang;
    utterance.rate = rate;
    utterance.pitch = pitch;
    utterance.volume = volume;
    speechSynthesis.speak(utterance);
  }
}
